<div class="container-fluid">
    <div class="row">
        <div class="col">
            <h4>Are you sure you want to delete the count?</h4>
        </div>
    </div>

    <div class="row mb-4">
        <div class="col-sm-6">
            <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancelDialog()">Cancel</button>
        </div>
        <div class="col-sm-6">
            <button type="button" class="btn btn-outline-primary btn-block" (click)="confirmDialog()">Confirm</button>
        </div>
    </div>

</div>
